import Homepage from 'components/Homepage/Homepage'
import HtmlHead from 'components/shared/HtmlHead/HtmlHead'
import Loader from 'components/shared/Loader/Loader'
import SiteHeader from 'components/shared/SiteHeader/SiteHeader'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { withNamespaces } from 'react-i18next'
import { connect } from 'react-redux'
import { fetchCollections } from 'redux/actions/CollectionActions'
import { fetchFeatured } from 'redux/actions/FeaturedActions'

export const HomepageContainer = ({
  collections,
  featured,
  i18n,
  fetchCollectionsAction,
  fetchFeaturedProjectsAction,
}) => {
  const [shouldRender, setShouldRender] = useState(false)

  useEffect(() => {
    fetchCollectionsAction(i18n.language)
  }, [fetchCollectionsAction, i18n.language])

  useEffect(() => {
    fetchFeaturedProjectsAction(i18n.language)
  }, [fetchFeaturedProjectsAction, i18n.language])

  useEffect(() => {
    setShouldRender(true)
  }, [])

  return (
    <div>
      <HtmlHead />
      <Loader display={collections.loading || featured.loading} />
      <SiteHeader />
      {shouldRender && !(collections.loading || featured.loading) && (
        <Homepage collections={collections} featured={featured} />
      )}
    </div>
  )
}

HomepageContainer.propTypes = {
  collections: PropTypes.object.isRequired,
  featured: PropTypes.object.isRequired,
  i18n: PropTypes.object.isRequired,
  fetchCollectionsAction: PropTypes.func.isRequired,
  fetchFeaturedProjectsAction: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => {
  const { collections, featured } = state
  return {
    collections,
    featured,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCollectionsAction: (locale) => dispatch(fetchCollections(locale)),
    fetchFeaturedProjectsAction: (locale) => dispatch(fetchFeatured(locale)),
  }
}

export default withNamespaces('translations')(
  connect(mapStateToProps, mapDispatchToProps)(HomepageContainer)
)
